import { createActionGroup, emptyProps } from '@ngrx/store';

export const LearnSupportMenuActions = createActionGroup({
  source: 'Learn Support Menu',
  events: {
    'Help Center Clicked': emptyProps(),
    'Live Training Clicked': emptyProps(),
    'Product Updates Clicked': emptyProps(),
    'Professional Services Clicked': emptyProps(),
    'Support Contacted': emptyProps(),
  },
});
